import axios from 'axios';
import { User } from '../models/user.models';
import { BaseService } from './base.service';

export default class TrainingCommentsService extends BaseService {
  public async createTrainingComment(trainingId: any, message: string, memberId?: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    const url = memberId
      ? `${this.backendUrl}/v2/training/${trainingId}/comments?memberId=${memberId}`
      : `${this.backendUrl}/v2/training/${trainingId}/comments`;

    return axios.post(
      url,
      {
        message,
      },
      {
        headers: {
          'x-access-token': user.token,
        },
      }
    );
  }

  public async getTrainingComments(trainingId: any, memberId?: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    let url = `${this.backendUrl}/v2/training/${trainingId}/comments`;

    if (memberId) {
      url += `?memberId=${memberId}`;
    }

    return axios.get(url, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async getTeamTrainingComments(trainingId: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return axios.get(`${this.backendUrl}/v2/training/${trainingId}/comments/team`, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async deleteTrainingComment(trainingId: any, commentId: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return axios.delete(`${this.backendUrl}/v2/training/${trainingId}/comment/${commentId}`, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async updateTrainingComment(trainingId: any, commentId: any, message: string) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return axios.put(
      `${this.backendUrl}/v2/training/${trainingId}/comment/${commentId}`,
      { message },
      {
        headers: {
          'x-access-token': user.token,
        },
      }
    );
  }

  public async markCommentsAsRead(trainingId: any, memberId?: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    let url = `${this.backendUrl}/v2/training/${trainingId}/comments/read`;

    if (memberId) {
      url += `?memberId=${memberId}`;
    }

    return axios.post(
      url,
      {},
      {
        headers: {
          'x-access-token': user.token,
        },
      }
    );
  }

  public async markTeamCommentsAsRead(trainingId: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return axios.post(
      `${this.backendUrl}/v2/training/${trainingId}/comments/team/read`,
      {},
      {
        headers: {
          'x-access-token': user.token,
        },
      }
    );
  }
}
